import { render, staticRenderFns } from "./QuestionContentResume.vue?vue&type=template&id=c58d3448"
import script from "./QuestionContentResume.vue?vue&type=script&lang=js"
export * from "./QuestionContentResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports